import { IPortalUserSummary } from 'Modules/Communication/PortalUsers/shared/models/PortalUsers'

export interface SystemState {
  communication: {
    portalSummary: {
      data: IPortalUserSummary | null
      loading: boolean
      error: string
    }
  }
}

export const getPortalSummary = (state: SystemState) =>
  state.communication.portalSummary
